/* globals __CLIENT__, __DEVELOPMENT__ */

import { PropTypes } from 'react';

if (__CLIENT__ && !__DEVELOPMENT__) {
  // Initialise Sentry error tracking for client-side bundle
  require('../../vendor/Raven'); // eslint-disable-line
}

/**
* App component, container for all routes and components.
* Sets up error tracking and global async requirements.
*/
const App = ({ children }) => children;

App.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./app/src/components/App/index.jsx